import { pgEnum } from 'drizzle-orm/pg-core';

/**
 * Payment method used for vendor payments.
 * Determines how remittances are issued to vendors.
 */
export const vendor_payment_method = pgEnum('vendor_payment_method', [
  'CHECK',
  'ACH',
  'WIRE',
  'CASH',
]);

/**
 * Transaction type at the scale.
 * - SALE: Customer pays us (existing behavior, default)
 * - PURCHASE: We pay vendor (new AP flow)
 */
export const scale_transaction_type = pgEnum('scale_transaction_type', [
  'SALE',
  'PURCHASE',
]);

/**
 * Status workflow for payable notes.
 * Mirrors invoice status but for AP documents.
 */
export const payable_note_status = pgEnum('payable_note_status', [
  'DRAFT',     // Created, not yet finalized
  'OPEN',      // Finalized, has balance due (0% to 99% paid)
  'PAID',      // balanceDue = 0
  'VOID',      // Cancelled/voided
]);

/**
 * Status workflow for remittances (payments to vendors).
 * Tracks the lifecycle of outgoing payments.
 */
export const remittance_status = pgEnum('remittance_status', [
  'PENDING',     // Scheduled/created, not yet sent
  'PROCESSING',  // In transit (ACH/wire processing)
  'COMPLETED',   // Settled, payment received by vendor
  'VOIDED',      // Cancelled before completion
  'FAILED',      // Failed (ACH rejected, wire failed, etc.)
]);
